import {
  CheckCircleOutlined,
  EditOutlined,
  StopOutlined,
} from "@ant-design/icons";
import { PageHeader, Popconfirm, message, Tooltip } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import { TableItemDinamico, ButtonItem, dineroDisabledMask } from "../../../Components/Items";

class Indirectos extends Component {
  tableRef = null;
  state = {
    idEditarInsumoCompuesto: null,
    todasIndirectos: [],
    loading: false,
    totalRecords: 0,
  };
  consultarIndirectos(params) {
    this.setState({ loading: true })
    axios
      .post(
        "indirectos/selectTodasIndirectos",
        { empresaId: this.props.empresaId, ...params },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        this.setState({ loading: false })
        if (res.data.success === 2) {
          this.setState({
            todasIndirectos: res.data.data,
            totalRecords: res.data.totalRecords || 0,
          });
        } else {
          this.setState({ todasIndirectos: [] });
          message.info('No se pudo consultar información de los indirectos')
        }
      });
  }
  refrescarIndirectos() {
    if (this.tableRef) {
      this.tableRef.updateExternalFilters({});
    }
  }
  deshabilitarIndirecto(value) {
    axios
      .post(
        "indirectos/deshabilitarIndirecto",
        { indirectoId: value, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          message.success("Indirecto deshabilitado");
        } else {
          message.error("Sucedio un error y no se pudo deshabilitar");
        }
        this.refrescarIndirectos();
      });
  }
  habilitarIndirecto(value) {
    axios
      .post(
        "indirectos/habilitarIndirecto",
        { indirectoId: value, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          message.success("Indirecto habilitado");
        } else {
          message.error("Sucedio un error y no se pudo habilitar");
        }
        this.refrescarIndirectos();
      });
  }

  agregarIndirecto() {
    this.props.history.push("/panel/agregarIntangible");
  }
  editarIndirecto(id) {
    this.props.history.push("/panel/editarIntangible", { id });
  }

  render() {
    const columns = [
      {
        title: "Codigo",
        dataIndex: "codigo",
        key: "codigo",
        defaultSortOrder: 'ascend',
        sorter: (a, b) => {
          if (a.codigo < b.codigo) {
            return -1;
          }
          if (a.codigo > b.codigo) {
            return 1;
          }
          return 0;
        },
        buscar: "codigo",
        width: "5%",
      },
      {
        title: "Clave",
        dataIndex: "clave",
        key: "clave",
        sorter: true,
        buscar: "clave",
        width: "5%",
      },
      {
        title: "Descripción",
        dataIndex: "descripcion",
        key: "descripcion",
        sorter: true,
        buscar: "descripcion",
        width: "30%",
      },
      {
        title: "Tipo de Insumo",
        dataIndex: "tipoDeInsumo",
        key: "tipoDeInsumo",
        buscar: "tipoDeInsumo",
        width: "16%",
      },
      {
        title: "Unidad",
        dataIndex: "unidad",
        key: "unidad",
        buscar: "unidad",
        width: "6%",
      },
      {
        title: "Costo",
        dataIndex: "costo",
        key: "costo",
        sorter: true,
        render: (value, record) => {
          if(record.calculo){
            return record.porcentaje+' %'
          } else {
            return dineroDisabledMask(value)
          }
        },
        width: "6%",
        align: 'right'
      },
      {
        title: "Accion",
        dataIndex: "accion",
        key: "accion",
        align: "center",
        width: "12%",
        onHeaderCell: () => ({
          style: { textAlign: 'center', padding: '4px' }
        }),
        onCell: () => ({
          className: "acciones-sin-hover",
          style: { textAlign: 'center', padding: '4px' }
        }),
        render: (value, record) => {
          let buttons = [];

          buttons.push(
            <Tooltip title="Editar Intangible" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
              <ButtonItem
                key={`editar-${record._id}`}
                type="default"
                size="small"
                cyan
                icon={<EditOutlined />}
                onClick={() => this.editarIndirecto(record._id)}
              >
              </ButtonItem>
            </Tooltip>
          );

          if (record.estado === 1) {
            buttons.push(
              <Popconfirm
                key={`deshabilitar-${record._id}`}
                title="Seguro que quieres deshabilitar este indirecto"
                onConfirm={() => this.deshabilitarIndirecto(record._id)}
                okText="Si"
                cancelText="No"
              >
                <Tooltip title="Deshabilitar" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                  <ButtonItem
                    type="default"
                    size="small"
                    lima
                    icon={<CheckCircleOutlined />}
                  >
                  </ButtonItem>
                </Tooltip>
              </Popconfirm>
            );
          } else {
            buttons.push(
              <Popconfirm
                key={`habilitar-${record._id}`}
                title="Seguro que quieres habilitar este indirecto"
                onConfirm={() => this.habilitarIndirecto(record._id)}
                okText="Si"
                cancelText="No"
              >
                <Tooltip title="Habilitar" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                  <ButtonItem
                    type="default"
                    size="small"
                    rojo
                    icon={<StopOutlined />}
                  >
                  </ButtonItem>
                </Tooltip>
              </Popconfirm>
            );
          }

          return <div className="acciones-container">{buttons}</div>;
        },
      },
    ];
    return (
      <>
        <PageHeader
          title="Intangibles"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={
            <ButtonItem
              type="primary"
              key="agregarIntangible"
              onClick={this.agregarIndirecto.bind(this)}
              olivo
              className="botonAgregar"
            >
              Agregar Intangible
            </ButtonItem>
          }
        />
        <TableItemDinamico
          ref={(ref) => (this.tableRef = ref)}
          onRef={(ref) => (this.tableRef = ref)}
          totalRecords={this.state.totalRecords}
          loading={this.state.loading}
          size="small"
          onFetchData={this.consultarIndirectos.bind(this)}
          dataSource={this.state.todasIndirectos}
          columns={columns}
          filterStorageKey={"indirectos" + this.props.empresaId}
          onRow={(record) => ({
            onDoubleClick: () => this.editarIndirecto(record._id),
          })}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(Indirectos);
